import { connect } from 'react-redux';
import {setVisiblePopover} from '../../redux/contactForm'
import {setVisibleForm} from '../../redux/contactForm'
import {sendError} from '../../redux/contactForm'
import Powerbanks from './Powerbanks';

let mapStateTooProps = (state) => {
    if (state.lang.currentLanguage === 'Ru') {
        return {
            state: state.powerbank.ru,
            apps: state.apps,
            form: state.contactForm.ru,
            bools: state.contactForm.bools
        }
    } else { 
        return {
            state: state.powerbank.en,
            apps: state.apps,
            form: state.contactForm.en,
            bools: state.contactForm.bools
        }
    }
}

let mapDispatchToProps = (dispatch) => {
    return {
        setVisibleForm: (visible) => {
            dispatch(setVisibleForm(visible))
        },
        setVisiblePopover: (visible) => {
            dispatch(setVisiblePopover(visible))
        },
        sendError: (visible) => {
            dispatch(sendError(visible))
        }
    }
}

const PowerbanksContainer = connect(mapStateTooProps, mapDispatchToProps)(Powerbanks)

export default PowerbanksContainer